var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReasonableContract = function SvgReasonableContract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 58"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#reasonable-contract_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.319,
    d: "M43.362 30.684h10.993M43.362 35.96h7.475M43.362 41.238h4.398"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m38.299 43.784-.287.254a2.64 2.64 0 0 1-1.885.663l-16.99-.851c-1.38-9.32-5.42-28.03-5.237-28.776.13-.523 1.448-1.133 2.435-1.558a5.1 5.1 0 0 1 2.013-.42h11.588c.573 0 1.123.223 1.534.623l7.183 6.994c.34.33.531.785.531 1.26v19.839c0 .753-.322 1.47-.885 1.971"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#reasonable-contract_svg__b)",
    fillOpacity: 0.4,
    d: "m38.299 43.784-.287.254a2.64 2.64 0 0 1-1.885.663l-16.99-.851c-1.38-9.32-5.42-28.03-5.237-28.776.13-.523 1.448-1.133 2.435-1.558a5.1 5.1 0 0 1 2.013-.42h11.588c.573 0 1.123.223 1.534.623l7.183 6.994c.34.33.531.785.531 1.26v19.839c0 .753-.322 1.47-.885 1.971"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M30.814 13.281c.24.105.464.252.656.439l7.182 6.994c.223.217.381.488.464.782l-1.69.615-7.696-7.475z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#reasonable-contract_svg__c)",
    fillOpacity: 0.3,
    d: "M30.814 13.281c.24.105.464.252.656.439l7.182 6.994c.223.217.381.488.464.782l-1.69.615-7.696-7.475z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#reasonable-contract_svg__d)",
    fillOpacity: 0.3,
    d: "M30.814 13.281c.24.105.464.252.656.439l7.182 6.994c.223.217.381.488.464.782l-1.69.615-7.696-7.475z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.948 14.744h14.636l7.731 7.298v21.226c0 .639-.518 1.157-1.157 1.157h-21.21c-.639 0-1.157-.518-1.157-1.157V15.9c0-.639.518-1.157 1.157-1.157"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#reasonable-contract_svg__e)",
    fillOpacity: 0.02,
    d: "M14.948 14.744h14.636l7.731 7.298v21.226c0 .639-.518 1.157-1.157 1.157h-21.21c-.639 0-1.157-.518-1.157-1.157V15.9c0-.639.518-1.157 1.157-1.157"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.66,
    d: "M14.948 14.744h14.636l7.731 7.298v21.226c0 .639-.518 1.157-1.157 1.157h-21.21c-.639 0-1.157-.518-1.157-1.157V15.9c0-.639.518-1.157 1.157-1.157Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#reasonable-contract_svg__f)",
    d: "M29.95 20.35v-5.936l7.475 7.255H31.27a1.32 1.32 0 0 1-1.319-1.319"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.27,
    height: 16.27,
    x: 6.426,
    y: 21.891,
    fill: "#000",
    rx: 8.135
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.27,
    height: 16.27,
    x: 6.426,
    y: 21.891,
    fill: "#895FFC",
    rx: 8.135
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.27,
    height: 16.27,
    x: 6.426,
    y: 21.891,
    fill: "url(#reasonable-contract_svg__g)",
    fillOpacity: 0.6,
    rx: 8.135
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.446,
    d: "m10.765 29.845 2.475 2.892 4.756-5.061"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFD",
    d: "m32.404 29.198-.871 3.415 7.652-6.986V23.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#reasonable-contract_svg__h)",
    fillOpacity: 0.2,
    d: "m32.404 29.198-.871 3.415 7.652-6.986V23.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "m31.093 36.11-.818 4.32 8.91-8.647v-2.859z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "m31.093 36.11-.818 4.32 8.91-8.647v-2.859z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m34.104 34.09-.394.361-3.757 1.27 1.586-3.63.394-.361z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m42.773 26.14-8.67 7.949-2.17-2.36L40.6 23.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m47.077 22.125-4.304 4.016-2.171-2.36 4.416-3.833z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "reasonable-contract_svg__b",
    x1: 43.361,
    x2: -15.56,
    y1: 28.925,
    y2: 6.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reasonable-contract_svg__c",
    x1: 37.205,
    x2: 37.645,
    y1: 17.934,
    y2: 22.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reasonable-contract_svg__d",
    x1: 33.687,
    x2: 29.071,
    y1: 14.856,
    y2: 12.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reasonable-contract_svg__e",
    x1: 32.809,
    x2: 7.745,
    y1: 29.804,
    y2: 29.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reasonable-contract_svg__f",
    x1: 29.652,
    x2: 48.985,
    y1: 20.897,
    y2: -0.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reasonable-contract_svg__g",
    x1: 14.56,
    x2: 14.56,
    y1: 21.891,
    y2: 38.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E90F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reasonable-contract_svg__h",
    x1: 32.589,
    x2: 41.164,
    y1: 26.946,
    y2: 25.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "reasonable-contract_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h58v58H0z"
  })))));
};
export default SvgReasonableContract;